import type { Item, ItemFieldEntry, Kit } from '@cheqroom/api';
import { createContext, FC, PropsWithChildren, useContext } from 'react';

import { type InfoConfig, useInfoConfig } from '../Info/Info.context';

export type KitInfoKit = Pick<Kit, '_id' | 'status' | 'canReserve' | 'canOrder'> & {
	items?: { custody?: Pick<NonNullable<Item['custody']>, '_id' | 'name'> | null }[];
	fields?: Record<string, unknown>;
};

export interface KitInfoKitValue {
	kit: KitInfoKit;
	fieldDefs?: ItemFieldEntry[];
}

const KitInfoKitContext = createContext<KitInfoKitValue | null>(null);

export const KitInfoKitProvider: FC<PropsWithChildren<KitInfoKitValue>> = ({ children, ...value }) => (
	<KitInfoKitContext.Provider value={value}>{children}</KitInfoKitContext.Provider>
);

const useKitInfoKit = (): KitInfoKitValue => {
	const value = useContext(KitInfoKitContext);
	if (value == null) {
		throw new Error('useKitInfoContext was used outside of KitInfo');
	}
	return value;
};

export const useKitInfoContext = (): InfoConfig & KitInfoKitValue => ({
	...useInfoConfig(),
	...useKitInfoKit(),
});
